var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13H13.75M6.25 18H13.75M16.25 24.25H3.75C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V4.25C1.25 3.58696 1.51339 2.95107 1.98223 2.48223C2.45107 2.01339 3.08696 1.75 3.75 1.75H10.7325C11.064 1.75007 11.3819 1.88181 11.6163 2.11625L18.3838 8.88375C18.6182 9.11812 18.7499 9.43601 18.75 9.7675V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25Z",
    stroke: "url(#paint0_linear_11040_67544)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11040_67544",
    x1: 1.25,
    y1: 1.75,
    x2: 23.0577,
    y2: 18.7115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267857,
    stopColor: "#66AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508929,
    stopColor: "#84B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758929,
    stopColor: "#9CB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.ff233b5b56d7f103ddebe0977f1e0827.svg";
export { ForwardRef as ReactComponent };